"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasureCommand = void 0;
const MeasureValue_1 = require("../../course/lib/MeasureValue");
const Command_1 = require("../Command");
const CommandType_1 = require("../lib/CommandType");
/**
 * Changes time signature used. Numerator and denominator from the value are
 * divided by one another. Formula to get the amount of milliseconds per
 * measure: `60000 * MEASURE * 4 / BPM`. After inserting a note, the current
 * timing point is increased by milliseconds per measure divided by amount of
 * notes in the current measure. Command can only be placed between measures.
 *
 * Example:
 *
 * ```
 * #MEASURE 4/4
 * 1000100011101010,
 * #MEASURE 2/4
 * 0212,
 * ```
 */
class MeasureCommand extends Command_1.Command {
    constructor(value) {
        super(CommandType_1.CommandType.Measure);
        this.value = value;
    }
    static parse(args) {
        if (args.length === 0) {
            return undefined;
        }
        const value = args[0]
            .split('/')
            .map((v) => parseInt(v.trim(), 10))
            .filter((v) => !isNaN(v));
        if (value.length !== 2) {
            return undefined;
        }
        const measureValue = new MeasureValue_1.MeasureValue(value[0], value[1]);
        return new MeasureCommand(measureValue);
    }
    toString() {
        return `${super.toString()} ${this.value.toString()}`;
    }
}
exports.MeasureCommand = MeasureCommand;
